export const BLEED = 12;

const GREEN = '#1f7a4d';
const GREEN2 = '#2faf6a';
const BLUE = '#1f4f8a';
const BLUE2 = '#2f6db0';
const STEEL = '#8fa6a0';

// A vertical expressway-sign rail with stacked CJK characters and a small
// route number. Sits in the card's edge padding so it never covers body text.
function VRail({ x, y, h, chars, label, color, color2 }) {
  const top = y + 18;
  const railH = h - 56;
  const cx = x + 8;
  const n = chars.length;
  const step = Math.min(15, (railH - 26) / Math.max(1, n));
  return (
    <g>
      <rect x={x} y={top} width={16} height={railH} rx={4} fill={color} opacity={0.92} />
      <rect x={x} y={top} width={16} height={railH} rx={4} fill="none" stroke={color2} strokeWidth={0.8} opacity={0.85} />
      {chars.map((ch, i) => (
        <text key={i} x={cx} y={top + 15 + i * step} fill="#eafff2" fontSize={9} fontWeight="700" textAnchor="middle">{ch}</text>
      ))}
      <text x={cx} y={top + railH - 7} fill="#d3ece0" fontSize={6} fontWeight="800" textAnchor="middle">{label}</text>
    </g>
  );
}

// Japanese-expressway signage frame. Steel border, green left rail / blue right
// rail, route-sign tabs hanging off the top edge, a centred bottom wordmark and
// chevrons. Tabs/labels live in the bleed + edge padding to avoid body text.
export default function TokyoExpresswayFrame({ w, h, radius = 12 }) {
  const W = w + BLEED * 2;
  const H = h + BLEED * 2;
  const x = BLEED;
  const y = BLEED;
  const r = radius + 1;
  return (
    <div style={{ position: 'absolute', top: -BLEED, left: -BLEED, width: W, height: H, pointerEvents: 'none' }}>
      <svg width={W} height={H} xmlns="http://www.w3.org/2000/svg">
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke={STEEL} strokeWidth={1.2} opacity={0.5} />
        <rect x={x - 2} y={y - 2} width={w + 4} height={h + 4} rx={r + 2} ry={r + 2} fill="none" stroke={GREEN2} strokeWidth={0.6} opacity={0.4} />

        <VRail x={x - 6} y={y} h={h} chars={['都', '心', '環', '状', '線']} label="C1" color={GREEN} color2={GREEN2} />
        <VRail x={x + w - 10} y={y} h={h} chars={['新', '宿', '線']} label="4" color={BLUE} color2={BLUE2} />

        {/* top-left tab: C1 shield + 首都高 */}
        <g>
          <rect x={x + 14} y={y - 9} width={94} height={16} rx={4} fill={GREEN} opacity={0.95} />
          <rect x={x + 17} y={y - 6.5} width={11} height={11} rx={2} fill="none" stroke="#eafff2" strokeWidth={1} />
          <text x={x + 22.5} y={y + 1.5} fill="#eafff2" fontSize={7} fontWeight="800" textAnchor="middle">C1</text>
          <text x={x + 33} y={y - 1} fill="#eafff2" fontSize={6.5} fontWeight="800">首都高</text>
          <text x={x + 33} y={y + 5} fill="#d3ece0" fontSize={4} fontWeight="700">SHUTO EXPWY</text>
        </g>

        {/* top-right tab: 東京 Tokyo + exit arrow */}
        <g>
          <rect x={x + w - 92} y={y - 9} width={78} height={16} rx={4} fill={GREEN} opacity={0.95} />
          <text x={x + w - 86} y={y - 1} fill="#eafff2" fontSize={7} fontWeight="800">東京</text>
          <text x={x + w - 86} y={y + 5} fill="#d3ece0" fontSize={4.2} fontWeight="700">Tokyo</text>
          <path d={`M ${x + w - 27} ${y - 2} l 7 0 l 0 7 M ${x + w - 27} ${y + 5} l 7 -7`} stroke="#eafff2" strokeWidth={1.2} fill="none" />
        </g>

        {/* bottom wordmark + chevrons */}
        <text x={x + w / 2} y={y + h + 8} fill={STEEL} fontSize={6.5} fontWeight="800" letterSpacing={2} textAnchor="middle">TOKYO EXPRESSWAY</text>
        {[0, 1, 2, 3].map(i => (
          <path key={i} d={`M ${x + w - 26 + i * 6} ${y + h + 4} l 3 3 l -3 3`} stroke={BLUE2} strokeWidth={1.1} fill="none" opacity={0.8} />
        ))}
      </svg>
    </div>
  );
}
